import { toast } from 'react-toastify'

import { IS_LOCAL_ENV, IS_DEV_ENV } from '@shared/config'

export const notyError = (text, options = {}) => {
  if (IS_LOCAL_ENV || IS_DEV_ENV) {
    // eslint-disable-next-line no-console
    console.error('ERROR', text)
  }

  toast.error(text, options)
}

export const notySuccess = (text, options = {}) => toast.success(text, options)

export const notyWarning = (text, options = {}) => {
  if (IS_LOCAL_ENV || IS_DEV_ENV) {
    // eslint-disable-next-line no-console
    console.warn('WARNING', text)
  }

  toast.warn(text, options)
}

export const notyInfo = (text, options = {}) => toast.info(text, options)
